import { render, staticRenderFns } from "./PagedListAdvertisement.vue?vue&type=template&id=45ae92ad&"
import script from "./PagedListAdvertisement.vue?vue&type=script&lang=js&"
export * from "./PagedListAdvertisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports